import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHeadset, FaShoppingBag, FaPhoneAlt, FaTools, FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page-root">
      {/* Hero Section */}
      <section className="contact-hero-section">
        <Container>
          <div className="contact-hero-content text-center">
            <span className="contact-eyebrow">Get In Touch</span>
            <h1 className="contact-main-title">Direct Support & Inquiries</h1>
            <p className="contact-subtitle">
              Have a question about our mobile phones, service support, or sales? Reach out directly to our dedicated support teams.
            </p>
          </div>
        </Container>
      </section>

      {/* Direct Contact Cards Section */}
      <section className="contact-cards-section">
        <Container>
          <Row className="g-4 justify-content-center">
            {/* Customer Care Card */}
            <Col lg={5} md={6} sm={12}>
              <div className="contact-card customer-care-card">
                <div className="contact-card-icon-box">
                  <FaHeadset className="contact-card-icon text-primary" />
                </div>
                <span className="contact-card-tag">Support & Service</span>
                <h3 className="contact-card-title">Customer Care</h3>
                <p className="contact-card-desc">
                  For after-sales service, warranty coverage, troubleshooting, and general product assistance.
                </p>
                <div className="contact-phone-display">
                  <span className="contact-phone-label">Helpline Number:</span>
                  <a href="tel:01146115412" className="contact-phone-val">
                    011-46115412
                  </a>
                </div>
                <a href="tel:01146115412" className="contact-call-btn primary-btn">
                  <FaPhoneAlt className="me-2" /> Call Customer Care
                </a>
              </div>
            </Col>

            {/* Sales Query Card */}
            <Col lg={5} md={6} sm={12}>
              <div className="contact-card sales-card">
                <div className="contact-card-icon-box">
                  <FaShoppingBag className="contact-card-icon text-accent" />
                </div>
                <span className="contact-card-tag">Commercial & Retail</span>
                <h3 className="contact-card-title">Sales Query</h3>
                <p className="contact-card-desc">
                  For new device purchases, dealership inquiries, bulk orders, and corporate partnerships.
                </p>
                <div className="contact-phone-display">
                  <span className="contact-phone-label">Sales Hotline:</span>
                  <a href="tel:7303747666" className="contact-phone-val">
                    +91 73037 47666
                  </a>
                </div>
                <a href="tel:7303747666" className="contact-call-btn secondary-btn">
                  <FaPhoneAlt className="me-2" /> Call Sales Hotline
                </a>
                <a 
                  href="https://wa.me/917303747666" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="contact-call-btn whatsapp-btn mt-3"
                >
                  <FaWhatsapp className="me-2 whatsapp-icon" /> Chat on WhatsApp
                </a>
              </div>
            </Col>
          </Row>

          {/* Quick Service Center Banner */}
          <div className="contact-sc-banner mt-5">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
              <div>
                <h4 className="mb-1 contact-sc-title">Need Walk-in Repair or Service?</h4>
                <p className="mb-0 contact-sc-desc">
                  Visit any of our 600+ authorized service centers across 28 states in India.
                </p>
              </div>
              <Link to="/service-centre" className="apple-btn apple-btn-primary whitespace-nowrap">
                <FaTools className="me-2" /> Find Service Center
              </Link>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Contact;
